import { memo } from 'react'
import { ReactComponent as FavoriteIcon } from '../../assets/icons/favorites_category.svg'

const VNFavoriteIcon = ({ className }) => <FavoriteIcon className={className} />

export default memo(VNFavoriteIcon)
